<template>
  <a-card style="margin: 10px" :bordered="false">
    <div class="table-page-search-wrapper" style="margin-bottom: 10px">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="18">
            <a-form-item label="员工名称">
              <a-input v-model="queryParam.name" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="18">
            <a-form-item label="手机号">
              <a-input v-model="queryParam.phone" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="18">
            <a-form-item label="门店">
              <a-input v-model="queryParam.shopName" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="18">
            <a-form-item label="权限类型">
              <a-select v-model="queryParam.authType" style="width: 180px">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="authAdmin">授权后台</a-select-option>
                <a-select-option value="authSetting">授权配置</a-select-option>
                <a-select-option value="authReport">授权查阅报表</a-select-option>
                <a-select-option value="authPostSale">授权售后服务</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="18">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="search()">查询</a-button>
              <a-button style="margin-left: 8px" @click="Reset()">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator" style="margin-bottom: 10px;text-align: right">
      <a-button type="primary" icon="plus" @click="$refs.staffAdd.add()">新建</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      showPagination="true"
    >
      <template slot="authPostSale" slot-scope="text, record">
        <a-switch :checked="text" @change="authPostSale(record)"/>
      </template>
      <template slot="authAdmin" slot-scope="text, record">
        <a-switch :checked="text" @change="authAdmin(record)"/>
      </template>
      <template slot="authSetting" slot-scope="text, record">
        <a-switch :checked="text" @change="authSetting(record)"/>
      </template>
      <template slot="authReport" slot-scope="text, record">
        <a-switch :checked="text" @change="authReport(record)"/>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-switch checked-children="正常" un-checked-children="冻结"  :checked="text === 'normal'" @change="changeStatus(record)"/>
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="$refs.staffAdd.edit(record)" style="margin-right: 10px">编辑</a>
        <a @click="resetPass(record)">密码重置</a>
        <a @click="$refs.staffPassword.editPass(record)">修改密码</a>
        <!-- <a  type="dashed"  @click="delStaff(record)" style="color: red;left: 10px">删除</a>-->
        <!--<a-popconfirm-->
        <!--title="确定要删除该员工?"-->
        <!--ok-text="是"-->
        <!--cancel-text="否"-->
        <!--@confirm="confirm(record)"-->
        <!--@cancel="cancel"-->
        <!--&gt;-->
        <!--<a href="#">删除</a>-->
        <!--</a-popconfirm>-->
      </template>
    </s-table>
    <staff-add ref="staffAdd" @ok="handleOk"/>
    <common-alert ref="commonAlert" @ok="handleOk"/>
    <staff-password ref="staffPassword" @ok="handleOk"/>
  </a-card>

</template>
<script>

  import {getAxios, postAxios} from '@/api/request'
  import staffAdd from './modules/staffAdd.vue'
  import staffPassword from './modules/staffPassword.vue'
  import {STable, Ellipsis} from '@/components'
  import commonAlert from '../common/commonAlert.vue'

  export default {
    name: 'staff',
    components: {
      staffAdd,
      STable,
      Ellipsis,
      commonAlert,
      staffPassword
    },
    data() {
      return {
        data: [],
        pagination: {},
        queryParam: {
          name: '',
          authType: '',
          shopName: '',
          phone: ''
        },
        loading: false,
        columns: [
          {
            title: '员工编号',
            dataIndex: 'staffNo'
          },
          {
            title: '员工姓名',
            dataIndex: 'name'
          },
          {
            title: '手机号',
            dataIndex: 'phone'
          },
          {
            title: '店铺名称',
            dataIndex: 'shopName'
          },
          {
            title: '余额(元)',
            dataIndex: 'balance',
            customRender: (text, row, index) => {
              return text/100
            }
          },
          {
            title: '已提现(元)',
            dataIndex: 'withdrawal',
            customRender: (text, row, index) => {
              return text/100
            }
          },
          {
            title: '授权售后服务',
            dataIndex: 'authPostSale',
            scopedSlots: {customRender: 'authPostSale'}
          },
          {
            title: '后台权限',
            dataIndex: 'authAdmin',
            scopedSlots: {customRender: 'authAdmin'}
          },
          {
            title: '配置权限',
            dataIndex: 'authSetting',
            scopedSlots: {customRender: 'authSetting'}
          },
          {
            title: '查阅报表权限',
            dataIndex: 'authReport',
            scopedSlots: {customRender: 'authReport'}
          },
          {
            title: '用户状态',
            dataIndex: 'status',
            scopedSlots: {customRender: 'status'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: {customRender: 'action'}
          }
        ],
        // 加载数据方法 必须为 Promise 对象 county
        loadData: parameter => {
          const parms = {}
          parms.pageNo = parameter.pageNum
          parms.pageSize = parameter.pageSize
          parms.name = this.queryParam.name
          parms.authType = this.queryParam.authType
          parms.shopName = this.queryParam.shopName
          parms.phone = this.queryParam.phone
          return postAxios('staffList', parms)
            .then(res => {
              const data = {}
//              res = res.data
              console.log(res)
              data.data = res.rows
              data.pageNum = parameter.pageNum
              data.totalCount = res.total
              return data
            })
        }
      }
    },
    mounted() {

    },
    methods: {
      confirm(record) {
        console.log(record)
        const param = {}
        param.id = record.id
        param.status = 'frozen'
        const that = this
        postAxios('updateStaffStatus', param).then(res => {
          that.$message.success('删除成功')
          that.$refs.table.refresh()
        }).catch(err => {
          that.$message.error('删除失败')
        })

      },
      cancel(e) {
        console.log(e)
        this.$message.error('Click on No')
      },
      // 查询
      search() {
        this.$refs.table.refresh()
      },
      // 重置
      Reset() {
        this.queryParam.name = ''
        this.queryParam.authType = ''
        this.queryParam.shopName = ''
        this.queryParam.phone = ''
      },
      handleOk() {
        this.$refs.table.refresh()
      },
      handleTableChange(pagination, filters, sorter) {
        console.log(pagination)
        const pager = {...this.pagination}
        pager.current = pagination.current
        this.pagination = pager
        this.fetch({
          results: pagination.pageSize,
          page: pagination.current,
          sortField: sorter.field,
          sortOrder: sorter.order,
          ...filters
        })
      },
      authPostSale(record) {
        console.log('record', record)
        const that = this
        const param = {}
        param.authPostSale = !record.authPostSale
        param.authGive = record.authGive
        param.authAdmin = record.authAdmin
        param.authSetting = record.authSetting
        param.authReport = record.authReport
        param.status = record.status
        param.id = record.id
        postAxios('updatePermissions', param).then(res => {
          that.$refs.table.refresh()
        }).catch(err => {
        })
      },
      authAdmin(record) {
        console.log('record', record)
        const that = this
        const param = {}
        param.authPostSale = record.authPostSale
        param.authGive = record.authGive
        param.authAdmin = !record.authAdmin
        param.authSetting = record.authSetting
        param.authReport = record.authReport
        param.status = record.status
        param.id = record.id
        postAxios('updatePermissions', param).then(res => {
          that.$refs.table.refresh()
        }).catch(err => {
        })
      },
      authSetting(record) {
        console.log('record', record)
        const that = this
        const param = {}
        param.authPostSale = record.authPostSale
        param.authGive = record.authGive
        param.authAdmin = record.authAdmin
        param.authSetting = !record.authSetting
        param.authReport = record.authReport
        param.status = record.status
        param.id = record.id
        postAxios('updatePermissions', param).then(res => {
          that.$refs.table.refresh()
        }).catch(err => {
        })
      },
      authReport(record) {
        console.log('record', record)
        const that = this
        const param = {}
        param.authPostSale = record.authPostSale
        param.authGive = record.authGive
        param.authAdmin = record.authAdmin
        param.authSetting = record.authSetting
        param.authReport = !record.authReport
        param.status = record.status
        param.id = record.id
        postAxios('updatePermissions', param).then(res => {
          that.$refs.table.refresh()
        }).catch(err => {
        })
      },
      changeStatus(record) {
        console.log('record', record)
        const that = this
        const param = {}
        param.authPostSale = record.authPostSale
        param.authGive = record.authGive
        param.authAdmin = record.authAdmin
        param.authSetting = record.authSetting
        param.authReport = record.authReport
        if (record.status === 'normal') {
          param.status = 'frozen'
        } else {
          param.status = 'normal'
        }
        param.id = record.id
        postAxios('updatePermissions', param).then(res => {
          that.$refs.table.refresh()
        }).catch(err => {
        })
      },
      // 密码重置
      resetPass(record) {
        const param = {}
        param.id = record.id
        param.password = this.$md5('123').toUpperCase()
        const that = this
        postAxios('resetPassword', param).then(res => {
          record.msg = '密码重置成功'
          that.$refs.commonAlert.resetPass(record)
        }).catch(err => {
          record.msg = '密码重置失败'
          that.$refs.commonAlert.resetPass(record)
        })
      },
      // 删除分店
      delStaff(record) {
        const param = {}
        param.id = record.id
        param.status = 'frozen'
        const that = this
        this.$confirm({
          title: '确认删除该数据?',
          content: '',
          okText: '确认',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            postAxios('updateStaffStatus', param).then(res => {
              that.$message.success('删除成功')
              that.$refs.table.refresh()
            }).catch(err => {
              that.$message.error('删除失败')
            })
          },
          onCancel() {
            console.log('Cancel')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/staff/staff.vue